import { render, staticRenderFns } from "./TaskDetailDialog.vue?vue&type=template&id=6b1d3ae0&scoped=true"
import script from "./TaskDetailDialog.vue?vue&type=script&lang=js"
export * from "./TaskDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./TaskDetailDialog.vue?vue&type=style&index=0&id=6b1d3ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1d3ae0",
  null
  
)

export default component.exports